module.exports = __webpack_public_path__ + "static/media/corn-head.427c282f.jpeg";